import Vue from 'vue';
import Vuex from 'vuex';
// import { resolve } from 'app-root-path';
// import { use } from 'vue/types/umd';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: localStorage.getItem('status') || '',
    auth : JSON.parse(localStorage.getItem('auth') || "{}"),
  },

  mutations: {
    auth_request(state){
      state.status = 'loading';
      localStorage.setItem('status', 'loading');
    },
    auth_success(state, user){
      var now = new Date()
      state.status = 'success';
      // user.expire = now.getTime() + 10000 // 10 detik
      user.expire = now.getTime() + (60000 * 100) // 30 menit
      state.auth = user;
      localStorage.setItem('status', 'success');
      localStorage.setItem('auth', JSON.stringify(user));
    },
    auth_error(state){
      state.status = 'error';
      state.auth = {};
      localStorage.setItem('status', 'error');
      localStorage.removeItem('auth');
    },
    logout(state){
      state.status = '';
      state.auth = {};
      localStorage.removeItem('status');
      localStorage.removeItem('auth');
    },
  },

  actions: {

    login({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        commit('auth_success', user);
        resolve(user);
      });
    },

    logout({commit}){
      return new Promise((resolve, reject) => {
          commit('logout');
          resolve();
      });
    },

  },
  
  modules: {
  },

  getters : {
	  isLoggedIn: state => !!state.auth.nik,
    authStatus: state => state.status,
    getUser: state => state.auth,
    isMaintenanceMode: () => { return Boolean( process.env.VUE_APP_IS_DOWN == "true"); },
	},
});
